'use strict';

var app = {};

(function ($) {
    var $doc = $(document);

    /** [1] */
    $.readyFn = {
        list: [],
        register: function (fn) {
            //console.log('Module Registered');

            $.readyFn.list.push(fn);
        },
        execute: function () {
            //console.log('Modules Executing');

            for (var i = 0; i < $.readyFn.list.length; i++) {
                try {
                    $.readyFn.list[i].apply(document, [$]);
                } catch (e) {
                    throw e;
                }
            }
        }
    };

    /** [2] */
    app = {
        expanded : false,

        initNav: function () {

            var body = $('body'),
                sub_menu = $('.menu_burger > .content #menu-burger > li > .sub-menu'),
                cta_back_html= $('.menu_burger .cta_back'),

                cta_parent = $('.menu_burger > .content #menu-burger > li.menu-item-has-children > a'),
                icon_search = $('.navigation .navigation_right .search_wrapper'),
                close_icon_search = $('#popin_search .close_popin_search'),
                popin_search = $('#popin_search');


                /*
                popin_search
                */
                // Open
                icon_search.click(function () {
                  body.addClass('no_scroll');
                  popin_search.addClass('active');
                  return false;
                });
                // Close
                close_icon_search.click(function () {
                  body.removeClass('no_scroll');
                  popin_search.removeClass('active');
                  return false;
                });



            //ACTIVATION MENU BURGER
            $('.menu_navigation>div .navigation .navigation_right nav#main_nav_burger #burger').click(function () {
                body.toggleClass('menu-open');
                $('.menu_burger').toggleClass('active');
                return false;
            });

            //ADD CTA BACK - SUBMENU MENU BURGER
            cta_back_html.css('display', 'block');
            sub_menu.prepend(cta_back_html);

            // console.log(cta_back_html);
            sub_menu.wrapInner('<div class="content"></div>');

            //ACTIVATION SUBMENU - MENU BURGER
            cta_parent.click(function () {
                var _this = $(this);
                _this.parent().find('> .sub-menu').addClass('active');
                return false;
            });

            //CLOSE SUBMENU - MENU BURGER
            $(document).on('click', '.cta_back', function () {
                var _this = $(this);
                _this.parent().parent().removeClass('active');
                return false;
            });
        },
        initAnimScroll: function () {
            //console.log('Module Executed: Anim Scroll');

            var $pageContent = $('body .anim-element');

            // Set GLOBAL scroll event (only for animations)

            var scrollHelpOffset = $('body').hasClass('') ? 0 : 30;

            $(window).on('scroll.page-anim', function (e) {

                $pageContent = $('body .anim-element');

                // content animation - WIP (for delay)

                $pageContent.each(function (i, el) {
                    // content animation (only once !)

                    if (($(window).height() + $(window).scrollTop() >= $(this).offset().top + scrollHelpOffset) && !$(this).hasClass('active') || $(window).height() + $(window).scrollTop() == $(document).height()) {

                        var active = function () {
                            $(el).addClass('anim-in');
                            $(el).addClass('animated');
                            $(el).removeClass('anim-element');

                            var video = $('.strate_video_full_screen .video > video');

                            video.removeAttr('controls').prop('muted', true);

                            if ($('.strate_video_full_screen').hasClass('animated')) {
                                video[0].play();
                            }
                        };

                        TweenMax.staggerTo($(el), 0, {
                            delay: .05 * (i / 2),
                            onComplete: active
                        });

                    }
                });


            }).trigger('scroll.page-anim');
        },
        initSticky: function () {
            // console.log('Module Executed: Sticky');

            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                    //hauteurMenu = $('.menu_navigation').height(),
                    //hauteurHeader = $('header.header').height(),
                    //positionActive = (hauteurHeader / 2) - hauteurMenu;


                if (scroll > 50) {
                    $(".menu_navigation").addClass("hidden");
                    $(".menu_navigation_fixed").addClass("activate");
                } else {
                    $(".menu_navigation").removeClass("hidden");
                    $(".menu_navigation_fixed").removeClass("activate");
                }
            });
        },
        initCarousel: function () {
            // console.log('Module Executed: Carousel');

            //BACKUP carousel
            // $(".boucle_projets").addClass('owl-carousel owl-theme');
            // $(".boucle_projets").owlCarousel({
            //     autoWidth:true,
            //     // center: true,
            //     loop: true,
            //     items: 1,
            //     nav: true,
            //     dots: false
            // });


            // boucle projet partout SAUF dans la page d'archive des projets
            $(".boucle_projets:not(.boucle_projets_archive)").addClass('owl-carousel owl-theme');
            $(".boucle_projets:not(.boucle_projets_archive)").owlCarousel({

                center: true,
                loop: true,
                stagePadding: 10,
                autoWidth: false,
                margin: 0,
                items: 1,
                nav: true,
                dots: true,
                responsive: {
                    480: {
                        items: 1,
                        center: false,
                        loop: true,
                        nav: true,
                        dots: true,
                        autoWidth: true,
                        stagePadding: 20,
                    },
                    768: {
                        items: 2,
                        stagePadding: 20,
                        margin: 10,
                        autoWidth: true,
                        loop: true,
                        nav: true,
                        dots: true,
                        center: false
                    },
                    1025: {
                        autoWidth:true,
                        // center: true,
                        loop: true,
                        items: 1,
                        nav: true,
                        dots: false
                    }
                }
            });


            // avec custom nav
            $('.fleches_autres_projets a.gauche').click(function() {
                $('.boucle_projets .owl-prev').trigger( "click" );
                return false;
            })
            $('.fleches_autres_projets a.droite').click(function() {
                $('.boucle_projets .owl-next').trigger( "click" );
                return false;
            })



            $(".container_slides").addClass('owl-carousel owl-theme');
            $(".container_slides").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: true,
                dots: false
            });

            // avec custom nav
            $('.fleches_slides a.gauche').click(function() {
                $('.container_slides .owl-prev').trigger( "click" );
            })
            $('.fleches_slides a.droite').click(function() {
                $('.container_slides .owl-next').trigger( "click" );
                return false;
            })

        

            $(".wrapper_slider_all_actu").addClass('owl-carousel owl-theme');
            $(".wrapper_slider_all_actu").owlCarousel({
                center: false,
                autoWidth: true,
                loop: true,
                items: 1,
                nav: false,
                dots: true,
                responsive: {
                    480:{
                        center: false,
                        autoWidth: true,
                        loop: true,
                        items: 2,
                        nav: false,
                        dots: true,
                    },
                    768:{
                        autoWidth:true,
                        loop: true,
                        items: 1,
                        nav: false,
                        dots: true
                    },
                    1025:{

                        dots: false
                    }
                }
            });
            // avec custom nav
            $('.fleches_nav_all_actu a.gauche').click(function() {

                $('.wrapper_slider_all_actu .owl-prev').trigger( "click" );
                return false;
            })
            $('.fleches_nav_all_actu a.droite').click(function() {
                $('.wrapper_slider_all_actu .owl-next').trigger( "click" );
                return false;
            })

            $(".js-wrapper-carousel-citations").addClass('owl-carousel owl-theme');
            $(".js-wrapper-carousel-citations").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: false,
                dots: true,
                responsive:{
                    768: {
                        dots: false,
                    }
                },
            });
            // avec custom nav
            $('.fleches-nav-carousel-citation a.gauche').click(function() {
                $('.js-wrapper-carousel-citations .owl-prev').trigger( "click" );
                return false;
            })
            $('.fleches-nav-carousel-citation a.droite').click(function() {
                $('.js-wrapper-carousel-citations .owl-next').trigger( "click" );
                return false;
            })

            $(".wrapper-carousel .js-wrapper-carousel-single").addClass('owl-carousel owl-theme');
            $(".wrapper-carousel .js-wrapper-carousel-single").owlCarousel({
                loop: true,
                margin: 0,
                items: 1,
                nav: false,
                dots: true,
            });
            // avec custom nav
            $('.wrapper-carousel .fleches-nav-carousel-single a.gauche').click(function() {
                $('.wrapper-carousel .js-wrapper-carousel-single .owl-prev').trigger( "click" );
                return false;
            })
            $('.wrapper-carousel .fleches-nav-carousel-single a.droite').click(function() {
                $('.wrapper-carousel .js-wrapper-carousel-single .owl-next').trigger( "click" );
                return false;
            })

            
        },
        initBugIE: function () {
            // console.log('Module Executed: Bug IE');

            function GetIEVersion() {
                var sAgent = window.navigator.userAgent;
                var Idx = sAgent.indexOf("MSIE");

                // If IE, return version number.
                if (Idx > 0)
                    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

                // If IE 11 then look for Updated user agent string.
                else if (!!navigator.userAgent.match(/Trident\/7\./))
                    return 11;

                else
                    return 0; //It is not IE
            }

            if (GetIEVersion() > 0) {
                $('body').addClass('ie');

                //MODERNIZR IE & EDGE
                /*
                if (!Modernizr.objectfit) {
                    var containerImages = $('.bg-cover');
                    containerImages.each(function () {
                        var $container = $(this),
                            imgUrl = $container.find('img').prop('src');
                        $container.find('img').hide();
                        if (imgUrl) {
                            $container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
                        }
                    });
                }
                */
            }
        },
        
        wpcf7mailsent: function(){
          // document.addEventListener( 'wpcf7mailsent', function( event ) {
          //    console.log('mail envoyé avec succès par wpf7');
          //    var reply = event.detail.apiResponse.message;
          //    $('.intro-collect-reply-wpf7').text(reply);
          //    $('.intro-collect-reply-wpf7').addClass('reply_ok');
          //   }, false );
        },
        menuMobile: function () {
            if( window.innerWidth < 1023 ) {
                setTimeout(function() {
                    $('body').addClass('pl-menu-resp');
                },300)
            }

            $('.respMenu').on(
                'click',
                function () {
                    $('body').toggleClass('pl-menu-open');
                }
            );

            $(window).resize(function () {
                if( window.innerWidth > 1023 ) {
                    $('body').removeClass('pl-menu-open pl-menu-resp');
                } else {
                    setTimeout(function() {
                        $('body').addClass('pl-menu-resp');
                    },300)
                }
            });
        },


        initShareLinkedin: function () {
            if ($('a[title="linkedin"]').length) {
                $('a[title="linkedin"]').click(function() {
                    var w = 500;
                    var h = 600;
                    var left = (screen.width/2)-(w/2);
                    var top = (screen.height/2)-(h/2);
                    window.open($(this).attr('href'),'mywindow','menubar=1,resizable=1,width='+w+',height='+h+',left='+left+',top='+top);
                    return false;
                });
            }
        },

        initFilters: function () {

                var dropdownContainers = document.querySelectorAll('.wrapper-dropdown-filter');
                dropdownContainers.forEach(function(container) {
                    var counter = container.querySelector('.compteur');
                    var dropdownButton = container.querySelector('.dropdown-button');
                    var dropdownContent = container.querySelector('.dropdown-content');
                    var checkboxes = dropdownContent.querySelectorAll('input[type="checkbox"]');

                    // Function to update counter
                    function updateCounter() {
                        var checkedCount = 0;
                        checkboxes.forEach(function(checkbox) {
                            if (checkbox.checked) {
                                checkedCount++;
                            }
                        });
                        counter.textContent = checkedCount;
                        if (checkedCount > 0) {
                            counter.classList.add('active');
                        } else {
                            counter.classList.remove('active');
                        }
                    }

                    // Update counter on page load
                    updateCounter();

                    // Update counter when checkbox changes
                    checkboxes.forEach(function(checkbox) {
                        checkbox.addEventListener('change', function() {
                            updateCounter();
                        });
                    });

                    // Toggle dropdown
                    dropdownButton.addEventListener('click', function(event) {
                        event.stopPropagation();
                        if (dropdownContent.classList.contains('show')) {
                            dropdownContent.classList.remove('show');
                            container.classList.remove('show');
                        } else {
                            closeAllDropdowns();
                            dropdownContent.classList.add('show');
                            container.classList.add('show');
                        }
                    });

                    // Close dropdowns when clicking outside
                    document.addEventListener('click', function(event) {
                        if (!event.target.matches('.dropdown-button') && !event.target.closest('.dropdown-content')) {
                            closeAllDropdowns();
                        }
                    });

                    // Close dropdowns when pressing Escape
                    document.addEventListener('keyup', function(event) {
                        if (event.key === 'Escape') {
                            closeAllDropdowns();
                        }
                    });

                    function closeAllDropdowns() {
                        dropdownContainers.forEach(function(container) {
                            container.querySelector('.dropdown-content').classList.remove('show');
                            container.classList.remove('show');
                        });
                    }
                });
               
        },

        initPlayerVideo: function () {
            const playersVideo = document.querySelectorAll('.js-wrapper-video');

            playersVideo.forEach($el => {
                const video = $el.querySelector('.js-video');
                const button = $el.querySelector('.js-icon-play');
                const thumbnail = $el.querySelector('.js-video-thumbnail');
        
                if (button) {
                    button.addEventListener('click', () => {
                        if (thumbnail && video) {
                            thumbnail.classList.add('hidden');
                            video.play();    
                        }
                    })
                }
            });
        }
    };

    /** [3] */
    $doc.ready(function () {
        $.readyFn.execute();
    });

    /** [4] */
    $.fn.ready = $.readyFn.register;

})
($);

/** [5] */
$(function () {
    loadScripts();
});

function loadScripts() {

    //init Global
    app.initNav();
    app.initSticky();
    app.initCarousel();
    app.initBugIE();
    app.wpcf7mailsent();
    app.initFilters();
    app.menuMobile();
    app.initShareLinkedin();
    app.initPlayerVideo();
}


$(function() {


    /*//////////////////////////////////////////////////
    //////////// ALL CLICK & CHANGE EVENTS ////////////
    /////////////////////////////////////////////////*/
  
  
    /*
    Page archive 
    */
  
    // VERSION DESKTOP
  
    $('.menu_local_archive .pseudo_select').click(function(e){
      // tests effectués avec find('.text') plutôt que _this et $(this)
      // Peau de banane avec $(this), _this => Comparaison incompréhensible à l'intérieur de each();
      var texte_initial = $(this).find('.text').text();
  
      $(this).toggleClass('show');
      $(this).find('.sub_menu').toggleClass('show');
  
      // ferme les autres pseudo_select dans tous les cas 
      $('.menu_local_archive .pseudo_select').each(function(){
        var texte_each = $(this).find('.text').text();
        if( texte_each != texte_initial){
          $(this).removeClass('show');
          $(this).find('.sub_menu').removeClass('show');
        }
      });
  
      checkCheckbox($(this));
  
      e.stopPropagation();
      return false;
    });
  
    $('.sub_menu_pseudo_select .item_pseudo_select').click(function(e){
      $(this).toggleClass('checked');
      var this_text = $(this).find('.slug').text();
  
      // traitement spécial pour les pseudo_select dichotomique
      var this_pseudo_select = $(this).parent().parent();
      if( this_pseudo_select.hasClass('dichoto')  ){
        this_pseudo_select.find('.item_pseudo_select').each(function(){
          var other_text = $(this).find('.slug').text();
          if(this_text!==other_text)$(this).removeClass('checked');
        });
      }
  
  
      checkCheckbox($(this).parents('.pseudo_select'));
  
      e.stopPropagation();
      return false;
    });
  
    function checkCheckbox($_this){
      var checkboxesChecked = $_this.find('.item_pseudo_select.checked').length;
      var compteur = $_this.find('.compteur');
      compteur.html(checkboxesChecked);
      if( checkboxesChecked > 0){
        compteur.addClass('active');
        $_this.addClass('active');
      } else {
        compteur.removeClass('active');
        $_this.removeClass('active');
      }
      return false;
    }
  
    function close_checkboxes(){
      $('.menu_local_archive .pseudo_select').removeClass('show');
      $('.menu_local_archive .sub_menu_pseudo_select').removeClass('show');
    }
  
    $('.menu_local_archive select.item').click(function(e){
      close_checkboxes();
  
      e.stopPropagation();
      return false;
    });
  
  
  
    /*
    FIN Page archive projets
    */
  
  
  
  
    /*
    NEWSLETTER
    */
    $("#newsletter_signup").on("submit", function (event) {
    
        //abort any previous requests
        var
            $form = $(this),
            $inputs = $form.find("input, select, button, textarea"),
            serializedData = $form.serialize();
  
        var request = $.ajax({
            url: wp_admin_ajax,
            type: 'post',
            data: {
                action: 'ajax_subscribe',
                data: serializedData
            },
            beforeSend: function () {
                //disable the input fields, cause submission will start now
                $inputs.prop("disabled", true);
            },
            success: function (response) {
                //success, we have an answer
                console.log("success", response );
                // $form.parent().find('p.response').remove(); // A quoi ça sert ? Pas de p.reponse sur le parent...
                // $form.parent().append('<p class="response newsletter-' + response.status + '">' + response.msg + '</p>');
                $form.parent().find('.reponse').addClass(response.status);
                $form.parent().find('.reponse').html(response.msg);
                $form.find("input[type='email']").val('');
            },
            error: function (response, textStatus, errorThrown) {
                //failllll
                console.log("error", response, textStatus, errorThrown );
            },
            complete: function () {
                //reenable the input fields again
                $inputs.prop("disabled", false);
            }
        });
        event.preventDefault();
    }); 
  
  }); // FIN DOM READY
